import { render, staticRenderFns } from "./user-menu-dropdown.vue?vue&type=template&id=1bdd3cf6&scoped=true"
import script from "./user-menu-dropdown.vue?vue&type=script&lang=js"
export * from "./user-menu-dropdown.vue?vue&type=script&lang=js"
import style0 from "./user-menu-dropdown.vue?vue&type=style&index=0&id=1bdd3cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdd3cf6",
  null
  
)

export default component.exports